<template>
  <card>
    <div class="row">
      <div class="col-12">
        <p>Welcome to the Sensoreal Admin Dashboard.</p>
      </div>
      <div class="todo-list col-12">
        <h4>Get started</h4>
        <label for="">Rest Screen</label>
        <ul>
          <li :class="{ 'done': !restBackgroundItems.length }">
            Rest screen background missing 
            <router-link v-if="restBackgroundItems.length" :to="{ path: '/settings/rest', hash: 'background-media'}">Fix</router-link>
          </li>
        </ul>
        <label for="">Page & Navigation</label>
        <ul>
          <li :class="{ 'done': !firstPageItems.length }">No pages created <router-link v-if="firstPageItems.length" to="/pages/new">Fix</router-link></li>
          <li :class="{ 'done': !navigationItems.length }">No pages linked to a navigation item <router-link v-if="navigationItems.length" to="/navigation">Fix</router-link></li>
        </ul>
        <label for="">Sidebar</label>
        <ul>
          <li :class="{ 'done': isGeneralSidebarLogoSet }">
            Sidebar logo missing 
            <router-link v-if="!isGeneralSidebarLogoSet" :to="{ path: '/settings/general', hash: 'sidebar-logo'}">Fix</router-link>
          </li>
          <li :class="{ 'done': isGeneralSidebarBrandLogoSet }">
            Sidebar brand logo missing 
            <router-link v-if="!isGeneralSidebarBrandLogoSet" :to="{ path: '/settings/general', hash: 'sidebar-brand-logo'}">Fix</router-link>
          </li>
          <li :class="{ 'done': isGeneralSidebarHeaderColourSet }">
            Sidebar Header colour missing 
            <router-link v-if="!isGeneralSidebarHeaderColourSet" :to="{ path: '/settings/general', hash: 'sidebar-header-colour'}">Fix</router-link>
          </li>
          <li :class="{ 'done': isGeneralSidebarDescriptionColourSet }">
            Sidebar description colour missing 
            <router-link v-if="!isGeneralSidebarDescriptionColourSet" :to="{ path: '/settings/general', hash: 'sidebar-description-colour'}">Fix</router-link>
          </li>
        </ul>
        <label for="">Live Section</label>
        <ul>
          <li :class="{ 'done': isLiveSelectionBackgroundSet }">
            Live selection background missing 
            <router-link v-if="!isLiveSelectionBackgroundSet" :to="{ path: '/settings/live', hash: 'selection-background'}">Fix</router-link>
          </li>
          <li :class="{ 'done': isLiveHeadingSet }">
            Live sidebar heading missing 
            <router-link v-if="!isLiveHeadingSet" :to="{ path: '/live/masterplan', hash: 'sidebar-heading'}">Fix</router-link>
          </li>
          <li :class="{ 'done': isLiveDescriptionSet }">
            Live sidebar description missing 
            <router-link v-if="!isLiveDescriptionSet" :to="{ path: '/live/masterplan', hash: 'sidebar-description'}">Fix</router-link>
          </li>
          <li :class="{ 'done': isLivingOptionSet }">
            No living option created 
            <router-link v-if="!isLivingOptionSet" :to="{ path: '/live/masterplan', hash: 'living-options'}">Fix</router-link>
          </li>
        </ul>
      </div>
    </div>   
  </card>
</template>

<script>
import { mapGetters } from 'vuex'
import { FETCH_CONFIG_ITEMS, FETCH_LIVING_OPTIONS, FETCH_NAVIGATION, FETCH_PAGES } from '@/store/actions.type'

export default {
  computed: {
    ...mapGetters([
      'configItems',
      'livingOptions',
      'navigation',
      'pages'
    ]),

    restBackgroundItems () {
      let restMedia = this.configItems.find(item => {
        return ['restMedia'].includes(item.key)
      })

      return restMedia && restMedia.value.length ? [] : ['No background selected']
    },

    firstPageItems () {
      return this.pages.length ? [] : ['Page missing']
    },

    navigationItems () {
      let isPageSet = false

      if (this.navigation.categories) {
        if (this.navigation.categories[0].children) {
          this.navigation.categories[0].children.forEach(child => {
            if (child.pageId) {
              isPageSet = true
            }
          })
        }
      }
      return isPageSet ? [] : ['No page attached to navigation item']
    },

    isLiveSelectionBackgroundSet () {
      const item = this.configItems.find(item => {
        return ['liveHereSelectionBackground'].includes(item.key)
      })

      return item && item.value ? true : false
    },

    isLiveHeadingSet () {
      const item = this.configItems.find(item => {
        return ['liveHereHeading'].includes(item.key)
      })

      return item && item.value.en ? true : false
    },

    isLiveDescriptionSet () {
      const item = this.configItems.find(item => {
        return ['liveHereDescription'].includes(item.key)
      })

      return item && item.value.en ? true : false
    },

    isLivingOptionSet () {
      return this.livingOptions.length ? true : false
    },

    isGeneralSidebarLogoSet () {
      const item = this.configItems.find(item => {
        return ['generalSidebarLogo'].includes(item.key)
      })

      return item && item.value ? true : false
    },

    isGeneralSidebarBrandLogoSet () {
      const item = this.configItems.find(item => {
        return ['generalSidebarBrandLogo'].includes(item.key)
      })

      return item && item.value ? true : false
    },

    isGeneralSidebarHeaderColourSet () {
      const item = this.configItems.find(item => {
        return ['generalSidebarHeaderColour'].includes(item.key)
      })

      return item && item.value ? true : false
    },

    isGeneralSidebarDescriptionColourSet () {
      const item = this.configItems.find(item => {
        return ['generalSidebarDescriptionColour'].includes(item.key)
      })

      return item && item.value ? true : false
    }
  },

  created () {
    this.$store.dispatch(FETCH_CONFIG_ITEMS)
    this.$store.dispatch('FETCH_LIVING_OPTIONS')
    this.$store.dispatch(FETCH_PAGES)
    this.$store.dispatch(FETCH_NAVIGATION)
  },

  methods: {
    toURL (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped lang="scss">
.todo-list {
  align-items: flex-start;
  display: flex;
  flex-direction: column;

  .done {
    opacity: .25;
    pointer-events: none;
    text-decoration: line-through;
  }
}
</style>